<app-file-upload
  #fileUpload
  [enableDocumentUpload]="enableDocumentUpload"
  [showMandatoryFileUploadMessage]="showMandatoryFileUploadMessage"
  (fileSelected)="onFileSelected($event)"></app-file-upload>

<div class="w-full mt-4 md:pr-6">
  <div
    *ngFor="let file of uploadedFiles; let i = index"
    class="flex justify-between items-center border rounded-md p-3 pr-0 mb-2">
    <div class="flex items-center">
      <i class="pi pi-file mr-3 text-xl"></i>
      <div>
        <p class="font-bold">{{ file.file.name }}</p>
        <p class="text-sm text-gray-600">
          {{ getFileTypeFromCode(file.docType) }}
        </p>
      </div>
    </div>
    <button
      pButton
      icon="pi pi-times"
      class="p-button-text text-black"
      (click)="onRemoveFile(i)"></button>
  </div>
  <app-document-info-popup
    [visible]="showDocumentInfoPopup"
    [documentTypes]="documentTypesToDisplay"
    [fileName]="selectedFile?.file?.name ?? ''"
    (close)="onCancelDocumentInfo()"
    (save)="onSaveDocumentInfo($event)"></app-document-info-popup>
</div>
